import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const e=t("thailand",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.4998H0V4.5Z"
                fill="white" />
            <path
                d="M0 9.59668H24V15.4037H0V9.59668Z"
                fill="#0052B4" />
            <path
                d="M0 4.5H24V7.05574H0V4.5ZM0 17.9443H24V20.5H0V17.9443Z"
                fill="#D80027" />
        </svg>
    `),l=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40012"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40012)">
            <g clip-path="url(#clip0_4915_40012)">
                <path
                    d="M-5.92969 0.519531H29.861V24.3795H-5.92969V0.519531Z"
                    fill="white" />
                <path
                    d="M-5.92969 8.12012H29.861V16.7799H-5.92969V8.12012Z"
                    fill="#0052B4" />
                <path
                    d="M-5.92969 0.519531H29.861V4.33082H-5.92969V0.519531ZM-5.92969 20.5685H29.861V24.3798H-5.92969V20.5685Z"
                    fill="#D80027" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40012">
                <rect
                    width="35.7907"
                    height="23.8604"
                    fill="white"
                    transform="translate(-5.92969 0.519531)" />
            </clipPath>
        </defs>
    </svg>
`,n=t("thailand_rounded",l),o=t("THB",l);export{o as THB,e as Thailand,n as ThailandRounded};
